<template>
  <div class="invoice_mini">
    <app-info :order="item" />

    <table class="table">
      <thead>
        <tr>
          <th class="text-left">
            D.Model (IMEI)
          </th>
          <th class="text-left">
            Price
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>{{ item.model | capitalize }} ({{ item.imei }})</td>
          <td>{{ item.cost | currency }}</td>
        </tr>
      </tbody>
    </table>

    <hr>
    <ul>
      <li>Customer Name: {{ item.fullName }}</li>
      <li>Phone : {{ item.phone }}</li>
      <li>Address : {{ item.address }}</li>
      <li v-if="item.sign">
        Sign :
        <img
          :src="item.sign"
          class="signature"
        >
      </li>
    </ul>
    <hr>
    <h3>Total Amount : {{ item.cost | currency }}</h3>
    <terms-conditions />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import AppInfo from "../common/ComInfo.vue";
import Terms from "../common/Terms.vue";

export default {
  components: {
    "app-info": AppInfo,
    "terms-conditions": Terms,
  },
  data() {
    return {
      item: {},
    };
  },
  computed: {
    ...mapGetters({
      info: "misc/currentSale",
      configs: "configs/overall",
    }),
  },
  mounted() {
    window.axios
      .get("/custom-product/" + this.$route.params.id)
      .then((response) => {
        this.$data.item = response.data.item;
        Event.$emit("printSize");
        Event.$emit("loadTerms", "customTerms");
      });
  },
};
</script>

<style type="text/css" scoped="">
.signature {
  height: 90%;
  width: 90%;
}
</style>
